import Dropzone from 'dropzone';

import { ModalHelper } from "../../B2bTools";

import $ from "jquery"



const dropzoneHtml = `
<div class="modal-dialog modal-lg">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title _title">{{ title }}</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body" >

			<div class="dropzone dropzone-single mb-3 _envDropzone " >
			</div>

		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
			<button type="button" disabled="disabled" class="btn btn-primary _ok "  >Ok</button>
		</div>
	</div>
</div>`



class DropzoneUnHelper {
    lance(title, elementOptions, onsuccess) {
        const THIS = this;
        let hasImg = false;

        const defaultOptions = {
            //url: param.url,
            maxFiles: 1,
            acceptedFiles: "image/jpeg,image/png",
            createImageThumbnails: true,
            uploadMultiple: false,
            thumbnailWidth: 120,
            paramName: "file_to_upload",

            init: function () {
                this.on('addedfile', async function (file) {
                    if (this.files.length > 1) {
                        this.removeFile(this.files[0]);
                    }
                });
                this.on("queuecomplete", async function () {
                    //console.log(this.files[0] )                    
                    if (this.files.length == 1 && this.files[0].status === "success") {
                        hasImg = true;
                    } else {
                        hasImg = false;
                    }
                    $("._ok", THIS.$c).prop("disabled", !hasImg);
                    //ppppModal.getOrCreateInstance(modal).hide();
                });
            },
        }


        ModalHelper.html(dropzoneHtml);
        //
        ModalHelper.show();
        //
        this.$c = $(ModalHelper.container);
        //
        const dropzoneContainer = $("._envDropzone", this.$c)[0];
        const options = {
            ...elementOptions,
            ...defaultOptions,
        };
        const drop = new Dropzone(dropzoneContainer, options);
        //        
        $("._title", this.$c).text(title);
        //
        $("._ok", this.$c).on("click", function () {
            onsuccess(drop);
            ModalHelper.hide();
        })

    }
}
export default DropzoneUnHelper
